package com.hyperether.goodjob.navigation

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

interface RouteScreen {
    val route: String
}


@Serializable
@SerialName("checkout")
data object Checkout : RouteScreen {
    override val route: String = "checkout"
}

@Serializable
@SerialName("history")
data object History : RouteScreen {
    override val route: String = "history"
}

@Serializable
@SerialName("statistics")
data object Statistics : RouteScreen {
    override val route: String = "statistics"
}

@Serializable
@SerialName("returns")
data object Returns : RouteScreen {
    override val route: String = "returns"
}

@Serializable
@SerialName("web_nav")
data object WebNav : RouteScreen {
    override val route: String = "web_nav"
}

@Serializable
@SerialName("splash")
data object Splash : RouteScreen {
    override val route: String = "splash"
}

@Serializable
@SerialName("scheduler")
data object Scheduler : RouteScreen {
    override val route: String = "scheduler"
}

@Serializable
@SerialName("onboarding")
data object Onboarding : RouteScreen {
    override val route: String = "onboarding"
}

@Serializable
@SerialName("register")
data object Register : RouteScreen {
    override val route: String = "register"
}

@Serializable
@SerialName("landing")
data object Landing : RouteScreen {
    override val route: String = "landing"
}

@Serializable
@SerialName("pricing")
data object Pricing : RouteScreen {
    override val route: String = "pricing"
}

@Serializable
@SerialName("dashboard")
data object Dashboard : RouteScreen {
    override val route: String = "dashboard"
}

@Serializable
@SerialName("jobs_web")
data object JobsWeb : RouteScreen {
    override val route: String = "jobs_web"
}

@Serializable
@SerialName("up_speed_job_details")
data object UpSpeedJobDetails : RouteScreen {
    override val route: String = "up_speed_job_details"
}

@Serializable
@SerialName("workspace")
data object Workspace : RouteScreen {
    override val route: String = "workspace"
}

@Serializable
@SerialName("add_new_workspace")
data object AddNewWorkspace : RouteScreen {
    override val route: String = "add_new_workspace"
}

@Serializable
@SerialName("add_new")
data object AddNew : RouteScreen {
    override val route: String = "add_new"
}

@Serializable
@SerialName("add_new_employee")
data class AddNewUser(val employeeId: String) : RouteScreen {
    override val route: String = "add_new_employee/$employeeId"
}

@Serializable
@SerialName("add_new_job")
data class AddNewJob(val jobId: String) : RouteScreen {
    override val route: String = "add_new_job/$jobId"
}

@Serializable
@SerialName("about_contact")
data object AboutContact : RouteScreen {
    override val route: String = "about_contact"
}

@Serializable
@SerialName("add_new_contact")
data class AddNewContact(val contactId: String) : RouteScreen {
    override val route: String = "add_new_contact/$contactId"
}

@Serializable
@SerialName("employees")
data object Users : RouteScreen {
    override val route: String = "employees"
}

@Serializable
@SerialName("employee_details")
data class UserDetails(val employeeId: String) : RouteScreen {
    override val route: String = "employee_details/$employeeId"
}

@Serializable
@SerialName("jobs")
data object Jobs : RouteScreen {
    override val route: String = "jobs"
}

@Serializable
@SerialName("job_details")
data class JobDetails(val jobId: String) : RouteScreen {
    override val route: String = "job_details/$jobId"
}

@Serializable
@SerialName("contacts")
data object Contacts : RouteScreen {
    override val route: String = "contacts"
}

@Serializable
@SerialName("contact_details")
data class ContactDetails(val contactId: String) : RouteScreen {
    override val route: String = "contact_details/$contactId"
}

@Serializable
@SerialName("add_new_site")
data class AddNewSite(val contactId: String, val siteId: String) : RouteScreen {
    override val route: String = "add_new_site/$contactId/$siteId"
}

@Serializable
@SerialName("map")
data object Map : RouteScreen {
    override val route: String = "map"
}

@Serializable
@SerialName("notifications")
data object Notifications : RouteScreen {
    override val route: String = "notifications"
}

@Serializable
@SerialName("dashboard_map")
data object DashboardMapScreen : RouteScreen {
    override val route: String = "dashboard_map"
}

@Serializable
@SerialName("profile_settings")
data object ProfileSettings : RouteScreen {
    override val route: String = "profile_settings"
}

@Serializable
@SerialName("settings_web")
data object SettingsWeb : RouteScreen {
    override val route: String = "settings_web"
}

@Serializable
@SerialName("cancel_subscription")
data object CancelSubscriptionScreen : RouteScreen {
    override val route: String = "cancel_subscription"
}

val availableScreens = listOf(
    Checkout,
    History,
    Statistics,
    Returns,
    WebNav,
    Splash,
    Scheduler,
    Onboarding,
    Register,
    Landing,
    Pricing,
    Dashboard,
    Workspace,
    AddNewWorkspace,
    AddNew,
    AddNewUser(""),
    AddNewJob(""),
    AboutContact,
    AddNewContact(""),
    Users,
    Jobs,
    JobDetails(""),
    UserDetails(""),
    Contacts,
    JobsWeb,
    ContactDetails(""),
    AddNewSite("", ""),
    Map,
    Notifications,
    DashboardMapScreen,
    CancelSubscriptionScreen,
    ProfileSettings,
    SettingsWeb
)

object Routes {
    val all: List<RouteScreen> = availableScreens
    val byRoute = all.associateBy { it.route }

    fun findByRoute(route: String): RouteScreen {
        if (route.contains("job_details")) {
            return JobDetails(route.getIdFromRoute())
        } else if (route.contains("employee_details")) {
            return UserDetails(route.getIdFromRoute())
        } else if (route.contains("contact_details")) {
            return ContactDetails(route.getIdFromRoute())
        } else if (route.contains("add_new_job")) {
            return AddNewJob(route.getIdFromRoute())
        } else if (route.contains("add_new_contact")) {
            return AddNewContact(route.getIdFromRoute())
        } else if (route.contains("add_new_employee")) {
            return AddNewUser(route.getIdFromRoute())
        } else if (route.contains("add_new_site")) {
            return AddNewSite(route.getIdFromRoute(),route.getIdFromRoute(2))
        } else {
            return byRoute[route] ?: Landing
        }
    }
}

fun String.getIdFromRoute(index: Int = 1) = this.split("/")[index]
